require('../modules/es7.array.includes');
module.exports = require('../modules/_core').Array;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/es7/array.js
// module id = 820
// module chunks = 0